import { useState } from 'react'
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { shape, func, bool, number } from 'prop-types'

const styles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}))

const tempCheckedDistance = (input) => {
  if (input !== 0) {
    return input
  }
  return ''
}

const isValid = (input) => {
  const { str, office, rgd, dc, test, shipt } = input
  return [str, office, rgd, dc, test, shipt].filter((v) => v).length > 0
}

const DistanceDropdownItem = (props) => {
  const classes = styles(props)
  const {
    callbackFromParentWorkerTypes,
    callbackFromParentIsValid,
    workerTypesFromParent,
    distanceFromParent,
    callbackFromParentDistance,
  } = props
  const [state, setState] = useState(workerTypesFromParent)

  const [checkedDistance, setCheckedDistance] = useState(
    tempCheckedDistance(distanceFromParent),
  )

  const handleChange = (event) => {
    setCheckedDistance(event.target.value)
    callbackFromParentDistance(event.target.value)
  }

  const handleCheckboxChange = (event) => {
    let tempData = { ...state, [event.target.name]: event.target.checked }
    setState(tempData)
    callbackFromParentWorkerTypes(tempData)
    callbackFromParentIsValid(isValid(tempData))
  }

  const { str, office, rgd, dc, test, shipt } = state
  const error = !isValid(state)

  return (
    <div>
      <FormControl className={classes.formControl}>
        <InputLabel id="distance-label">Distance</InputLabel>
        <Select
          labelId="distance-label"
          value={checkedDistance}
          onChange={handleChange}
        >
          <MenuItem value={5}>5 miles</MenuItem>
          <MenuItem value={10}>10 miles</MenuItem>
          <MenuItem value={15}>15 miles</MenuItem>
          <MenuItem value={20}>20 miles</MenuItem>
          <MenuItem value={30}>30 miles</MenuItem>
        </Select>
      </FormControl>
      <br />
      <FormControl
        required
        error={error}
        component="fieldset"
        className={classes.formControl}
      >
        <FormLabel component="legend">
          Select types of workers to contact
        </FormLabel>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={str}
                onChange={handleCheckboxChange}
                name="str"
              />
            }
            label="Store"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={office}
                onChange={handleCheckboxChange}
                name="office"
              />
            }
            label="HQ"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={rgd}
                onChange={handleCheckboxChange}
                name="rgd"
              />
            }
            label="Region Group District"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={dc}
                onChange={handleCheckboxChange}
                name="dc"
              />
            }
            label="Distribution Center"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={test}
                onChange={handleCheckboxChange}
                name="test"
              />
            }
            label="Test Location"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={shipt}
                onChange={handleCheckboxChange}
                name="shipt"
              />
            }
            label="Shipt Location"
          />
        </FormGroup>
        <FormHelperText>Please select at least one type</FormHelperText>
      </FormControl>
    </div>
  )
}

export default DistanceDropdownItem

DistanceDropdownItem.propTypes = {
  workerTypesFromParent: shape({
    str: bool.isRequired,
    office: bool.isRequired,
    rgd: bool.isRequired,
    dc: bool.isRequired,
    shipt: bool.isRequired,
  }),
  callbackFromParentWorkerTypes: func.isRequired,
  callbackFromParentIsValid: func.isRequired,
  distanceFromParent: number,
  callbackFromParentDistance: func.isRequired,
}
